import { Injectable } from "@angular/core";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";

@Injectable()
export class BaseManager {
    constructor(protected localStorageRepository: LocalStorageRepositoryInterface) {}

    public userIsLogged(): boolean {
        const token = this.localStorageRepository.getToken();
        if (token != null && token !== undefined) {
            return true;
        }
        return false;
    }

    public getCurrentLanguage() {
        return this.localStorageRepository.getCurrentLanguage();
    }

    public setCurrentLanguage(value: string) {
        this.localStorageRepository.setCurrentLanguage(value);
    }
}
